import { NavLink } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const NavBar = () => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  return (
    <header className="nav-wrapper">
      <div className="nav-brand">
        <span className="brand-logo" aria-hidden="true">
          ॐ
        </span>
        <div className="brand-text">
          <span className="brand-primary">आर्य समाज अबोहर</span>
          <span className="brand-secondary">Arya Samaj Abohar</span>
        </div>
      </div>
      <nav className="nav-links">
        <NavLink
          to="/"
          end
          className={({ isActive }) => (isActive ? "active" : undefined)}
        >
          गृह पृष्ठ
          <span className="caption">Home</span>
        </NavLink>
        <NavLink
          to="/gallery"
          className={({ isActive }) => (isActive ? "active" : undefined)}
        >
          चित्र मण्डप
          <span className="caption">Gallery</span>
        </NavLink>
        <NavLink
          to="/events"
          className={({ isActive }) => (isActive ? "active" : undefined)}
        >
          आयोजन
          <span className="caption">Events</span>
        </NavLink>
        <NavLink
          to="/leadership"
          className={({ isActive }) => (isActive ? "active" : undefined)}
        >
          पदाधिकारी
          <span className="caption">Leadership</span>
        </NavLink>
        <NavLink
          to="/contact"
          className={({ isActive }) => (isActive ? "active" : undefined)}
        >
          सम्पर्क करें
          <span className="caption">Contact</span>
        </NavLink>
        {user ? (
          <button type="button" className="nav-button" onClick={handleLogout}>
            प्रस्थान
            <span className="caption">Sign Out</span>
          </button>
        ) : (
          <NavLink
            to="/admin/login"
            className={({ isActive }) => (isActive ? "active" : undefined)}
          >
            प्रवेश
            <span className="caption">Admin</span>
          </NavLink>
        )}
      </nav>
    </header>
  );
};

export default NavBar;
